<template id="loading">
  <div
    :class="{ 'active': active }"
    class="LoadingScreen"
  >
    <div class="div spinner LoadingScreen-spinner" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {};
  },

  computed: {
    ...mapState('search', {
      active: (state) => state.uiLoadingState,
    }),
  },
};
</script>

<style lang="scss">
  @import "../../../../scss/abstracts/abstracts";

  .LoadingScreen-spinner {
    position: fixed;
    top: 50%;
    right: 50%;
    opacity: 0;
    width: 30px;
    height: 30px;
    z-index: 3;
    transform: translate(-50%, -50%);
    @include respond-to(md, max-width) {
      left: 50%;
    }
    &::after,
    &::before {
      content: "";
      position: absolute;
    }
    &::before {
      z-index: 8;
      left: 50%;
      margin-left: -10px;
      height: 20px;
      width: 20px;
      top: 50%;
      border-radius: 50%;
      line-height: 20px;
      margin-top: -10px;
      opacity: 0;
      border-top: 0px;
    }
    &::after {
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background: color($primary-color);
      opacity: 0;
      transition: all .3s ease;
      border-radius: 3px;
    }
  }

  .LoadingScreen {
    visibility: hidden;
    opacity: 0;
    transition: opacity .3s ease;
    height: 100%;
    width: 100%;
    background: rgba(255,255,255,.8);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    &.active {
      visibility: visible;
      opacity: 1;
      .LoadingScreen-spinner {
        position: absolute;
        opacity: 1;
        &::before {
          opacity: 1;
          border: 3px solid lighten(color($primary-color), 25);
          border-left: 3px solid color($primary-color);
          animation: loadingSpinner .8s linear;
          animation-iteration-count: infinite;
        }
      }
    }
  }
</style>
